<sc-activate-account-error-container>
  Si olvidaste tu contraseña, podés <a id="go-to-reset-password" [routerLink]="appRoutes.resetPassword">generar una nueva contraseña</a>
</sc-activate-account-error-container>